import type { SVGProps } from "react"
import { extraColors } from "../../utils/theme"

const SvgSortDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m12.75 15.44 2.72-2.72a.75.75 0 1 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06l2.72 2.72V6.75a.75.75 0 0 1 1.5 0v8.69Z"
      fill={extraColors.medium}
    />
  </svg>
)

export default SvgSortDown
